const canvasSketch = require("canvas-sketch");
const random = require("canvas-sketch-util/random");

const settings = {
  dimensions: [2048, 2048],
  animate: true,
  fps: 20,
  timeScale: 0.8,
};

const colors = [
  "#f1faee",
  "#a8dadc",
  "#457b9d",
  "#1d3557",
  "#fcbf49",
  "#f77f00",
  "#e63946",
];

function drawEclipse(context, x, y, radiusX, radiusY, rotation, curve) {
  context.beginPath();
  context.ellipse(x, y, radiusX, radiusY, rotation, 0, curve * 2 * Math.PI);
  context.fill();
  context.stroke();
}

function drawEclipseWithoutStroke(
  context,
  x,
  y,
  radiusX,
  radiusY,
  rotation,
  curve
) {
  context.beginPath();
  context.ellipse(x, y, radiusX, radiusY, rotation, 0, curve * 2 * Math.PI);
  context.fill();
}

function drawCylinder(context, x, y, w, h, offset) {
  drawEclipse(context, x, y, w / 2, offset, 0, 0.5);
  context.rect(x - w / 2, y - h, w, h);
  context.fill();
  context.stroke();
  drawEclipseWithoutStroke(
    context,
    x,
    y,
    w / 2 - context.lineWidth / 2,
    offset - context.lineWidth / 2,
    0,
    1
  );
  drawEclipse(context, x, y - h, w / 2, offset, 0, 1);
}

function drawLego(context, x, y, w, h) {
  drawCylinder(context, x, y, w, h, h / 2);
  drawCylinder(context, x, y - h, w / 2, h / 3, h / 4);
}

function drawStackOfLego(context, x, y, w, h, num) {
  for (let i = 0; i < num; i++) {
    context.fillStyle = colors[i];
    drawLego(context, x, y - h * i, w, h);
  }
}

const sketch = () => {
  return ({ context, width, height, time }) => {
    const brickHeight = 45;
    const brickWidth = 90;
    const maxHeight = colors.length;
    const freq = 0.09;

    const matrixWidth = 12;
    const matrixHeight = 15;

    context.strokeStyle = "black";
    context.lineWidth = 4;
    context.fillStyle = "#f1faee";

    context.beginPath();
    context.rect(0, 0, width, height);
    context.fill();

    for (let i = 1; i < matrixHeight; i++) {
      for (let j = 1; j < matrixWidth; j++) {
        drawCylinder(
          context,
          (width / matrixWidth) * j,
          brickHeight + (height / matrixHeight) * i,
          brickWidth / 2,
          brickHeight / 3,
          brickHeight / 4
        );
      }
    }

    for (let i = 1; i < matrixHeight; i++) {
      for (let j = 1; j < matrixWidth; j++) {
        let val = random.noise3D(j, i, time, freq);

        drawStackOfLego(
          context,
          (width / matrixWidth) * j,
          brickHeight + (height / matrixHeight) * i,
          brickWidth,
          brickHeight,
          Math.ceil(val * maxHeight)
        );
      }
    }
  };
};

canvasSketch(sketch, settings);
